var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeleclinicPlusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.52a8.48 8.48 0 1 0 0 16.96 8.48 8.48 0 0 0 0-16.96zm2.697 3.32-.001 2.463h2.464v5.394l-2.464-.001v2.464H7.304v-2.464H4.84V7.304h2.463V4.84h5.394zm-1.521 1.52H8.823v2.463H6.36v2.353h2.463v2.464h2.353v-2.463l2.464-.001V8.823h-2.463l-.001-2.463z",
    id: "6xsjnz5rna"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d0jz90xdcb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6xsjnz5rna"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#359EAD",
    fillRule: "nonzero",
    xlinkHref: "#6xsjnz5rna"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d0jz90xdcb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#359EAD",
    d: "M-80-30H99.01v81H-80z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleclinicPlusRound);
export default __webpack_public_path__ + "static/media/TeleclinicPlusRound.99406ce516db293a18dd028140f3ea19.svg";
export { ForwardRef as ReactComponent };